export default __webpack_public_path__ + "static/media/ecommerce-lg-1.26ee3cde.webp";